import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CounterBadge',
  props: {
    value: { default: 0 },
    variant: {},
    positionClasses: {}
  },
  setup(__props: any) {

const props = __props

const variantClasses = computed(() => {
  if (props.variant === 'primary') {
    return 'bg-primary-500 text-white outline-neutral-200'
  }

  return 'bg-neutral-300 text-grey-900 outline-white'
})

const positionClasses = computed(() => props.positionClasses || '-top-1.5 -right-1.5')

return (_ctx: any,_cache: any) => {
  return (__props.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([
      'absolute w-5 h-5 outline z-10 outline-solid overflow-hidden',
      'pointer-events-none flex items-center justify-center font-semibold text-t4 shadow-xs rounded-full',
      variantClasses.value,
      positionClasses.value
    ].join(' '))
      }, _toDisplayString(__props.value), 3))
    : _createCommentVNode("", true)
}
}

})